import {Button, Col, Container, Offcanvas, Row} from "react-bootstrap";
import {RRLogisticType} from "../../views/logistics/RRLogisticType";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons";
import MLogiticsDayDetailsItem from "./MLogiticsDayDetailsItem";
import React from "react";
import {LogisticReportDetailsContent} from "../../views/logistics/ReportDetails";

interface MLogisticsDayDetailsProps {
    selectedDay: Date,
    events: RRLogisticType[],
    onSelectedDayChange: (day: Date) => void
}

export default function MLogisticsDayDetails({
                                                 selectedDay,
                                                 events,
                                                 onSelectedDayChange
                                             }: MLogisticsDayDetailsProps) {
    const day = selectedDay.getDate();
    const month = selectedDay.toLocaleString('default', {month: 'long'}).toUpperCase();

    const [reportItem, setReportItem] = React.useState<RRLogisticType | undefined>(undefined);
    return (
        <Container fluid={true} className={"p-2"}>
            <Row>
                <Col xs={"auto"} className={"pt-2"}>
                    <Button variant={"outline-dark"}
                            onClick={event => onSelectedDayChange(new Date(selectedDay.setDate(selectedDay.getDate() - 1)))}>
                        <FontAwesomeIcon icon={faArrowLeft}/>
                    </Button>
                </Col>
                <Col className={"border shadow bg-white p-2 rounded"}>
                    <h1 className={"text-center"}>{day} {month}</h1>
                </Col>
                <Col xs={"auto"} className={"pt-2"}>
                    <Button variant={"outline-dark"}
                            onClick={event =>
                                onSelectedDayChange(new Date(selectedDay.setDate(selectedDay.getDate() + 1)))}>
                        <FontAwesomeIcon icon={faArrowLeft} style={{transform: "scaleX(-1)"}}/>
                    </Button>
                </Col>
            </Row>
            {
                events.length > 0 && events.map(
                    event =>
                        <MLogiticsDayDetailsItem
                            logistic={event}
                            key={event.id}
                            onClick={(logistic) => setReportItem(logistic)}
                        />
                )
            }
            {
                events.length === 0 &&
                <Row className={"border rounded mt-2 p-2"}>
                    <Col className={"text-center fs-3 fw-bold"}>
                        Няма планирани курсове за този ден
                    </Col>
                </Row>
            }

            <Offcanvas show={reportItem !== undefined}
                       onHide={() => {
                           setReportItem(undefined)
                       }}
                       placement={"bottom"}
                       className="offcanvas-auto-height"
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title><h3>Отчитане на логистика</h3></Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    {
                        reportItem !== undefined &&
                        <LogisticReportDetailsContent
                            logistic={reportItem!}
                            onDone={() => setReportItem(undefined)}
                        />
                    }
                </Offcanvas.Body>
            </Offcanvas>
        </Container>
    );
}
